import { AppShell } from '../layout';

function Root() {
  return <AppShell />;
}

export default Root;
